import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { hub } from "@/lib/hub-client";

export interface Review {
  id: string;
  reviewer_id: string;
  rating: number;
  review_text: string | null;
  helpful_count: number;
  created_at: string;
  updated_at: string;
}

export function useReviews(outcomeId: string) {
  return useQuery({
    queryKey: ["reviews", outcomeId],
    queryFn: async () => {
      const res = await hub.GET<{ items: Review[] }>(
        `/v1/outcomes/${outcomeId}/reviews?sort=newest&limit=10`,
      );
      if (!res.data) throw new Error("reviews fetch failed");
      return res.data.items;
    },
    enabled: Boolean(outcomeId),
  });
}

export function useSubmitReview(outcomeId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { rating: number; review_text?: string; job_id?: string }) => {
      const res = await hub.POST(`/v1/outcomes/${outcomeId}/reviews`, { body: input });
      if (!res.response.ok) {
        const text = await res.response.text().catch(() => "");
        throw new Error(`submit review: ${res.response.status} ${text.slice(0, 200)}`);
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["reviews", outcomeId] });
      qc.invalidateQueries({ queryKey: ["outcome"] });
    },
  });
}
